import React from "react";

const Quotes = () => (
  <section className="bg-grey-lightest py-8">
    <div className="w-5/6 max-w-xl ml-auto mr-auto">
        <div className="flex flex-wrap">
            <div>
                <h3 className="text-center font-bold text-base w-full py-8 mx-auto leading-normal font-title">Seattle by Bike offers guided bicycle tours
                that make memories and explore the best sights and sounds of the Emerald City. But don't just take our word for it...
                </h3>
            </div>
            
            <div className="w-full lg:w-1/3 px-6 py-6"  data-aos="fade" data-aos-duration="1200" data-aos-delay="300" data-aos-once="true">
                <div>
                    <div className="bg-brand-blue hover:bg-blue rounded shadow-lg overflow-hidden p-8 leading-normal">
                        <p className="text-brand-white mb-4 font-title font-bold">"I really enjoyed my tour on Seattle By Bike. Even as a local, I learned a bunch of new fun historical facts about my city! Totally recommended!"</p>
                        <p className="text-brand-white leading-tight font-body text-base">- Janae L.</p>
                    </div>
                </div>
            </div>
            <div className="w-full lg:w-1/3 px-6 py-6"  data-aos="fade" data-aos-duration="1200" data-aos-delay="300" data-aos-once="true">
                
                <div>
                    <div className="bg-brand-blue hover:bg-blue rounded shadow-lg overflow-hidden p-8 leading-normal">
                        <p className="text-brand-white mb-4 font-title font-bold">"Seattle by Bike was the perfect way to see the city! All the major sights, in just a few hours. The route was just as promised- mostly flat, with a few hills. I loved the tour!"</p>
                        <p className="text-brand-white leading-tight font-body text-base">- Yelena A.</p>
                    </div>
                </div>
            </div>
            <div className="w-full lg:w-1/3 px-6 py-6"  data-aos="fade" data-aos-duration="1200" data-aos-delay="300" data-aos-once="true">
                <div>
                    <div className="bg-brand-blue hover:bg-blue rounded shadow-lg overflow-hidden p-8 leading-normal">
                        <p className="text-brand-white mb-4 font-title font-bold">"Great sites! Great stories! Seattle by Bike was an excellent way to see the city and learn Seattle's history at the same time. I had a lot of fun on the tour."</p>
                        <p className="text-brand-white leading-tight font-body text-base">- Britt A.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
);

export default Quotes;


// WEBPACK FOOTER //
// ./src/components/Quotes/index.js